import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import HotelList from './HotelList';
import SearchHotelForm from './SearchHotelForm';
import UpgradeAccount, { checkForNeedUpgrade } from './UpgradeAccount';
import { Link } from 'react-router';

class AddHotel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needUpgrade: checkForNeedUpgrade(props.perms),
    };
  }
  componentWillMount() {
    if (this.state.needUpgrade && !this.props.onWaitlist) {
      this.props.checkWaitlist();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.perms !== nextProps.perms) {
      this.setState({ needUpgrade: checkForNeedUpgrade(nextProps.perms) });
    }
  }

  render() {
    if (this.state.needUpgrade) {
      return (
        <Layout>
          <UpgradeAccount
            onWaitlist={this.props.onWaitlist}
            joinWaitlist={this.props.joinWaitlist}
            waitlistisFetching={this.props.waitlistisFetching}
          />
        </Layout>
      );
    }

    if (this.props.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    if (this.props.needFetch) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    if (this.props.id) {
      return (
        <Layout>
          <div>{this.props.children}</div>
        </Layout>
      );
    }
    const hasSearch = this.props.hotels.length !== 0;
    return (
      <Layout>
        <div className="content-tours">
          <div className="container-fluid">
            <div className="row tour-head">
              <div className="col-md-12 tour-headText">
                <h2>Search Hotels</h2>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-12">
                <SearchHotelForm requestHotelSearch={this.props.requestHotelSearch} isAddHotelSearch={true}/>
              </div>
              <div className="col-md-12">
                <p>
                  Don't see what you're looking for? <span />
                  <Link to="addnewhotel" >
                    Add a new hotel.
                  </Link>
                  {/* <a href="#" className="">
                    Add a new hotel.
                    {/* <Link to="addnewhotel" >
                    
                  </Link> 
                  </a> */}
                </p>
              </div>
            </div>
            {this.props.isFetching && <Loading />}

            {hasSearch && (
              <HotelList
                hotels={this.props.hotels}
                requestHotelClaim={this.props.requestHotelClaim}
                viewHotel={() => { }}
                managed={false}
                readOnly={false}
              />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

AddHotel.propTypes = {
  id: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  hotels: PropTypes.arrayOf(PropTypes.object),
  requestHotelSearch: PropTypes.func.isRequired,
  requestHotelClaim: PropTypes.func.isRequired,
  onWaitlist: PropTypes.bool.isRequired,
  checkWaitlist: PropTypes.func.isRequired,
  joinWaitlist: PropTypes.func.isRequired,
};
AddHotel.defaultProps = {
  hotels: [],
  suggested: [],
};

export default AddHotel;



// WEBPACK FOOTER //
// src/routes/hotels/components/AddHotel.js